module.exports = __webpack_public_path__ + "img/info-white.0d3dbb14.svg";